import { persist } from 'zustand/middleware';
import { create } from 'zustand';
import { useEffect } from 'react';

interface CompanyBusinessLine {
    businessLineId: number;
    key?: string;
    value: string;
}

interface Company {
    idCompany: number;
    companyTradeName: string;
    companyLegalName: string;
    status?: string;
    businessLines?: CompanyBusinessLine[];
}

interface CompanyState {
    currentCompany: Company | null;
    setCurrentCompany: (company: Company | null) => void;
    companyLocked: boolean;
    setCompanyLocked: (locked: boolean) => void;
}

export const useCompanyStore = create<CompanyState>()(
    persist(
        (set) => ({
            currentCompany: null,
            setCurrentCompany: (company) => set({ currentCompany: company }),
            companyLocked: false,
            setCompanyLocked: (locked) => set({ companyLocked: locked }),
        }),
        {
            name: 'selected-company',
            partialize: (state) => ({ currentCompany: state.currentCompany }),
        }
    )
);

export const useCompanyLock = (locked: boolean = true) => {
    useEffect(() => {
        if (!locked) return;
        useCompanyStore.getState().setCompanyLocked(true);
        return () => useCompanyStore.getState().setCompanyLocked(false);
    }, [locked]);
};
